module.exports = __webpack_public_path__ + "img/92391da257d70f47427288f3a3861f55.b40e737c.jpg";